module.exports = __webpack_public_path__ + "1-28.png?fc99db3a8312e3ff5a805d1c091446ae";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1-28.png
// module id = 105
// module chunks = 0